import { useEffect, useState, useRef } from "react";
import { sanityClient, urlFor } from "../../sanity/client";
import { programsQuery } from "../../sanity/queries";
import { motion } from "framer-motion";
import "./Programs.css";


const Programs = () => {
  const headerRef = useRef(null);
  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    sanityClient.fetch(programsQuery).then(setPrograms);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("line-visible");
          observer.unobserve(entry.target); // clean & correct
        }
      },
      { threshold: 0.6 }
    );

    if (headerRef.current) {
      observer.observe(headerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <motion.section
     className="Programs" id="programs"
     initial= {{ opacity: 0, y:30 }}
     whileInView = {{ opacity: 1, y:0 }} 
     viewport= {{ once: false }}
     transition = {{ duration: 0.8, ease: "easeOut" }}
     >
      {/* Header */}
      <div
        ref={headerRef}
        className="programs-header-p line-animate reveal-line"
      >
        <span>Clases</span>
        <span className="stroke-text">y</span>
        <span>Programas</span>
      </div>

      <div className="program-categories">
        {programs.map((program) => (
          <div className="card" key={program._id}>
            <img
              src={urlFor(program.image).width(400).url()}
              alt={program.title}
            />
            <div className="intro">
              <h1>{program.title}</h1>
              <p>{program.description}</p>
            </div>
          </div>
        ))}
      </div>
    </motion.section>
  );
};

export default Programs;
